"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatMoney = void 0;
const locale = (new Intl.NumberFormat().resolvedOptions()).locale;
const formatMoney = (cents, currency = 'cad', int) => {
    const numberFormat = new Intl.NumberFormat(locale, { style: 'currency', currency, minimumFractionDigits: int ? 0 : 2 });
    return numberFormat.format(cents / 100);
};
exports.formatMoney = formatMoney;
